import * as React from "react";
import type { SVGProps } from "react";
const SvgFridge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 2H7C5.35 2 4 3.35 4 5v14c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3M7 4h10c.55 0 1 .45 1 1v4H6V5c0-.55.45-1 1-1m10 16H7c-.55 0-1-.45-1-1v-8h12v8c0 .55-.45 1-1 1m-8-8c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1m1-5c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55.45-1 1-1s1 .45 1 1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFridge;
